import classNames from 'classnames';
import { InputHTMLAttributes } from 'react';
import './Input.styles.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Input: React.FC<InputProps> =  (props) => {
  const { className, label, type = 'text', placeholder, ...rest } = props;

  const classes = classNames('res-input-field', className);

  return (
    <div className={classes}>
      {label && <label>{label}</label>}
      <input type={type} placeholder={placeholder || label} {...rest} />
    </div>
  );
};

export default Input;
